import { Container, Link, List, ListItem } from '@mui/material';

function Breadcrumbs(props) {
  let { links } = props;

  return (
    <Container>
      <List key={`crumbs`} className="breadcrumb-list">
        {links?.length > 0 &&
          links?.map((btn, index) => {
            return (
              <ListItem key={index}>
                {btn.uri?.length > 0 && !btn.uri?.includes('internal:#') && (
                  <Link href={new URL(btn.uri)?.pathname} title={btn.title}>
                    {btn.title?.toUpperCase()}
                  </Link>
                )}
                {(!btn.uri ||
                  (btn.uri?.length > 0 && btn.uri?.includes('internal:#'))) &&
                  btn.title?.toUpperCase()}
              </ListItem>
            );
          })}
      </List>
    </Container>
  );
}

export default Breadcrumbs;
